// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"0be378e0","453":"c055a13d"}[chunkId] + ".chunk.js";
};